import React from 'react'
import ClassesDataForm from './ClassesDataForm'

const AddClasses = () => {
  return (
    <div>
      <ClassesDataForm action="Add"/>
    </div>
  )
}

export default AddClasses
